import { useState, type FormEvent } from "react";
import { errorMessage } from "./errorMessage";

export interface TotpAdminResetProps {
  // 그 아이디의 등록을 지운다. 거절되면 reject.
  onReset: (username: string) => Promise<void>;
  // 확인창에 쓸 함수. 기본은 window.confirm — 시험에서 바꿔 끼운다. Promise 를 돌려줘도 된다 — 부르는 쪽이
  // 자기 모달(빨간 테두리 확인 창 등)로 묻고 사람이 고른 값으로 풀면 된다(안 깨는 추가, mops-code#97~104).
  confirm?: (message: string) => boolean | Promise<boolean>;
  // 마지막 관리자가 잠겼을 때의 운영 명령 안내(서비스마다 다르다). 없으면 안 그린다.
  lockoutHint?: string;
}

// 관리자 해제 — 기기를 잃은 사람의 복구 경로. 본인 확인은 화면 밖에서 한다.
export function TotpAdminReset({ onReset, confirm = (m) => window.confirm(m), lockoutHint }: TotpAdminResetProps) {
  const [username, setUsername] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setDone(null);
    const target = username.trim();
    setBusy(true);
    let ok = false;
    try {
      ok = await confirm(`${target} 의 2단계 인증을 해제하시겠습니까? 그 사람은 비밀번호만으로 로그인하게 되고, 다시 등록해야 합니다.`);
    } finally {
      setBusy(false);
    }
    if (!ok) return;
    setBusy(true);
    try {
      await onReset(target);
      setDone(`${target} 의 2단계 인증을 해제했습니다.`);
      setUsername("");
    } catch (err) {
      setError(errorMessage(err, "해제하지 못했습니다. 다시 시도해 주세요."));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="mtotp" onSubmit={submit}>
      <p className="mtotp-note">
        인증 앱이 깔린 기기를 잃어 로그인하지 못하는 사람의 등록을 지웁니다. 본인 확인은 화면 밖에서 해 주세요 — 여기서
        지우면 그 계정은 비밀번호만으로 들어옵니다.
        {lockoutHint ? " " + lockoutHint : ""}
      </p>
      <label className="b-field mtotp-field">
        <span className="b-field-label mtotp-label">아이디</span>
        <input className="b-input" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="alice" disabled={busy} required />
      </label>
      {done && (
        <div className="b-toast b-toast-success mtotp-toast" role="status">
          <div className="b-toast-text">
            <div className="b-toast-body">{done}</div>
          </div>
        </div>
      )}
      {error && (
        <div className="b-toast b-toast-danger mtotp-toast" role="alert">
          <div className="b-toast-text">
            <div className="b-toast-body">{error}</div>
          </div>
        </div>
      )}
      <div className="mtotp-actions">
        <button className="b-btn b-btn-danger b-btn-lg" type="submit" disabled={busy || username.trim() === ""}>
          해제
        </button>
      </div>
    </form>
  );
}
